import * as React from 'react';
import { cn } from '../../lib/utils.js';

// Minimal CSS-only tooltip — shows `label` in a dark pill above the
// wrapped element on hover. No Radix dependency; swap for
// @radix-ui/react-tooltip if we ever need delays or collision handling.
export function Tooltip({
  label,
  children,
  className,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span className={cn('group/tooltip relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2 translate-y-1 whitespace-nowrap rounded-md bg-foreground px-2.5 py-1 font-sans text-[11px] font-medium text-background opacity-0 shadow-md transition-all duration-150 group-hover/tooltip:translate-y-0 group-hover/tooltip:opacity-100"
      >
        {label}
        <span
          aria-hidden
          className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-foreground"
        />
      </span>
    </span>
  );
}
